import { atom } from 'jotai';
import { MedispaCalendarConfigObject, SesamiSDKGlobal, SesamiSlotObject } from '@/@types/calendar';

export const calendarConfigAtom = atom<MedispaCalendarConfigObject>(
  window.theme.medispaCalendarConfig,
);

export const todayAtom = atom<Date>(new Date());

export const selectedMonthAtom = atom<Date>(new Date());

export const selectedDayAtom = atom<Date | null>(null);

export const selectedTimeSlotAtom = atom<SesamiSlotObject['slots'][number] | null>(null);

export const productSesamisAtom = atom<Map<string, SesamiSDKGlobal>>(
  new Map<string, SesamiSDKGlobal>(),
);

export const dayAvailabilitiesAtom = atom<Map<string, Map<string, SesamiSlotObject['slots']>>>(
  new Map<string, Map<string, SesamiSlotObject['slots']>>(),
);

export const selectedProductAtom = atom<string>(
  window.theme.medispaCalendarConfig.products?.[0]?.id?.toString() ?? '',
);

export const calendarLoadingAtom = atom<boolean>(false);

export const errorMessageAtom = atom<string>('');
